import React, { useState } from 'react';
import axios from '../redux/actions/axios';
import { setToken } from '../redux/actions/user';
import { connect } from 'react-redux';
import { useHistory, useLocation } from "react-router-dom";
import { isDigitalMenu, notifyMe } from '../common/Functions';
import { messaging } from '../init-fcm';
import { setDeviceToken } from '../redux/actions/user';


function Login({ setToken, state, setDeviceToken }) {

    const location = useLocation();


    const [showOtp, setShowOtp] = useState(false);
    const [otpError, setOtpError] = useState(false);
    const [mobile, setMobile] = useState("");
    const [name, setName] = useState("");
    const [otp, setOtp] = useState("");
    const [clientId, setClientId] = useState(0);
    const history = useHistory();


    const sendOtp = async () => {
        const res = await axios.post('user/sendotp', {
            mobile: mobile,
            main_merchant_id: state.restaurant.merchant_id,
            name: name
        });
        if (res.data.code == 1) {
            setShowOtp(true)
            setClientId(res.data.details.client_id);
        }
        if (res.data.code == 2) setOtpError(res.data.msg)
    }

    const verifyOtp = async () => {
        const res = await axios.post('user/verifyotp', {
            otp: otp,
            main_merchant_id: state.restaurant.merchant_id,
            name: name,
            client_id: clientId
        });
        if (res.data.code == 1) {
            setToken(res.data.details.token);
            localStorage.setItem("token", res.data.details.token);
            if (!isDigitalMenu) {
                if (messaging) {
                    messaging.requestPermission()
                        .then(async function () {
                            const token = await messaging.getToken();
                            setDeviceToken(token);
                        })
                        .catch(function (err) {
                            console.log("Unable to get permission to notify.", err);
                        });
                    navigator.serviceWorker.addEventListener("message", (message) => notifyMe(message.title, message.title));
                }
            }
            if (location && location.isCheckout) {
                history.push("/checkout");
            } else {
                history.push("/");
            }

        }
        if (res.data.code == 2) setOtpError(res.data.msg)
    }


    return (
        <div className="container">
            <div className="login-container">
                <h3>Login</h3>
                <div className="input-row">
                    <div className="col-1">
                        <input type="text" className="form-input" placeholder="Enter Name" onChange={e => setName(e.target.value)} />
                    </div>
                </div>
                <div className="input-row">
                    <div className="col-1">
                        <input type="number" className="form-input" placeholder="Enter Mobile Number" onChange={e => setMobile(e.target.value)} />
                    </div>
                </div>
                <div className="input-row">
                    <div className="col-2">
                        <input className="btn w-100" type="button" value="Send OTP" onClick={sendOtp} />
                    </div>
                    {showOtp && <div className="col-2">
                        <input type="text" className="form-input " placeholder="Enter OTP" onChange={e => setOtp(e.target.value)} />
                        {otpError && <span className="input-error text-red">Please Enter Correct OTP</span>}
                    </div>}
                </div>
                {showOtp && <div className="input-row">
                    <div className="col-1 text-center">
                        <input className="btn w-50" type="submit" value="Submit" onClick={verifyOtp} />
                    </div>
                </div>}
            </div>
        </div>
    )
}


const mapStateToProps = (state) => ({ state: state })

export default connect(mapStateToProps, { setToken, setDeviceToken })(Login)
